import { useEffect } from 'react';
import CLASSNAMES from '../constants/CLASSNAMES';
import useTranslate from './useTranslate';
import IDS from '../constants/IDS';

const useMobileOverlay = () => {
  const { t } = useTranslate();

  useEffect(() => {
    const rootLayout = document.getElementById(IDS.rootLayout);

    rootLayout.classList.add(CLASSNAMES.SCROLL_LOCK);

    return () => {
      rootLayout.classList.remove(CLASSNAMES.SCROLL_LOCK);
    };
  });

  return { t };
};

export default useMobileOverlay;
